import { RepositoryFactory } from "@/js/repository/RepositoryFactory";
import { EmergencyClass } from "@/js/value-objects/emergency-class";
import { LatestDisaster } from "@/js/value-objects/latest-disaster";
import { DisasterClass } from "@/js/value-objects/disaster-class";
import { DisasterTranslator } from "@/js/translators/disasterTranslator";
const disasterInfoRepository = RepositoryFactory.get("disasterInfo");

const state = () => ({
  data: {},
  unfinished: {},
  latestDisaster: LatestDisaster.factoryDefault()
});
const getters = {};
const mutations = {
  setDisasterInfo(state, payload) {
    state.data = payload;
  },
  setUnfinishedDisasterInfo(state, payload) {
    state.unfinished = payload;
  },
  setLatestDisaster(state, payload) {
    state.latestDisaster = payload;
  }
};
const actions = {
  async loadDisasterInfo(context, screenId) {
    const disasters = await disasterInfoRepository.list(screenId);
    if (disasters.status < 300) {
      disasters.data.results = DisasterTranslator.sortByDisasterNo(
        disasters.data.results,
        true
      );
      context.commit("setDisasterInfo", disasters.data);
      const results = disasters.data.results.filter(
        disaster => EmergencyClass.factory(disaster.emerg_cls).isFn() === false
      );
      const data = {
        count: results.length,
        results: results
      };
      context.commit("setUnfinishedDisasterInfo", data);
    }
  },
  async loadLatestDisaster(context, screenId) {
    const disasters = await disasterInfoRepository.latest(screenId);
    if (disasters.status < 300) {
      const { data } = disasters;
      let latestDisaster = LatestDisaster.factoryDefault();
      if (data.count > 0) {
        const result = data.results[0];
        const disasterName = DisasterClass.getDisasterName(
          result.disaster_cls,
          result.disaster_name
        );
        const emergencyClass = EmergencyClass.factory(result.emerg_cls);
        latestDisaster = LatestDisaster.factory(
          disasterName,
          emergencyClass.toShortName(),
          result.max_oil_level
        );
      }
      context.commit("setLatestDisaster", latestDisaster);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
